<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header
      [header]="data().header"
      [subheader]="data().title_html"
      [imageUrl]="data().avatar_url"
      [separator]="false"
    />
  </ng-container>

  <ng-container body>
    <email-margin [height]="28" />
    <email-infobox [contents]="data().note_body_html" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer.text"
      color="light"
      presetName="paragraph"
      size="small"
    />&nbsp;
    <email-link
      [label]="data().footer.label"
      [href]="data().footer.href"
      [target]="data().footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
